import React from 'react';
import { Typography } from '@mui/material';
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';

export default function HtmlContent({ html }) {
  return <Typography
    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html ?? '', {}) }}
    component="p"
  />;
}

HtmlContent.propTypes = {
  html: PropTypes.string,
};

HtmlContent.defaultProps = {
  html: '',
};
